import { getLabelValueData, sortBussinessTypeData } from '../../utils/helper';
import { ActionTypes } from '../actions/actionTypes';

const initialCatalogProd = {
  branddetails: {
    brandinfo: {
      companyname: '',
      brandname: '',
      outlets: '',
      brandorigin: undefined,
      establishmentyear: '',
      franchiseyear: '',
      googlerating: '',
      fnbtype: '',
      description: '',
      logo: '',
      businessmodel: [],
    },
    statutoryinfo: {
      gstin: '',
      pan: '',
      tin: '',
      cin: '',
    },
    natureofbusinessinfo: {
      businesscategoryname: [],
      categoryname: [],
      subcategoryname: [],
      othercategory: '',
      ownershiptype: '',
      annualturnover: '',
      ceoname: '',
      websiteurl: '',
      googlebusinessurl: '',
      instagramurl: '',
    },
  },
  franchisedetails: {
    investmentinfo: [
      {
        businesstype: '',
        spacearea: '',
        setupcost: '',
        rawmaterialcost: '',
        licensescost: '',
        miscellaneousexpense: '',
        securitydeposit: '',
        franchisefees: '',
        additionaldetails: '',
      },
    ],
    marketinginfo: {
      marketing: 'brand',
      marketingtype: [],
    },
    masterinfo: {
      country: [],
      state: [],
      city: [],
      masterfranchisefees: '',
      setupcost: '',
      totalinvestment: '',
      royalty: '',
      agreementyears: '',
      roi: '',
    },
    analysisinfo: {
      rent: '',
      electricityexpenses: '',
      royalty: '',
      royalty_unit: 'percent',
      agreementyears: '',
      workingcapital: 500000,
      roi: '',
      miscellaneousexpenses: '',
      totalexpenses: '',
      brand_revenuesharing: '',
      brand_revenuesharing_unit: 'percent',
      franchise_revenuesharing: '',
      franchise_revenuesharing_unit: 'percent',
      securitydeposit: '',
    },
    cityinfo: {
      existingcountry: [],
      existingstate: [],
      existingcity: [],
      expansioncountry: [],
      expansionstate: [],
      expansionscity: [],
      blockcountry: [],
      blockstate: [],
      blockcity: [],
    },
  },
  pagesinfo: {
    aboutus: {
      desc: '',
      img: '',
    },

    support: {
      desc: '',
      img: '',
    },
    awards: [
      {
        desc: '',
        img: '',
      },
    ],
    products: [
      {
        desc: '',
        img: '',
      },
      {
        desc: '',
        img: '',
      },
    ],
    faqs: [
      {
        question: '',
        answer: '',
      },
      {
        question: '',
        answer: '',
      },
    ],
    others: {
      heading: '',
      desc: '',
      img: '',
    },
  },
  additionalinfo: {
    // costbifurcationinfo: {
    //   rent: '',
    //   salary: '',
    //   products: '',
    //   marketing: '',
    //   miscellaneous: '',
    //   wastage: '',
    //   accomadation: '',
    //   otherinfo: '',
    //   profitmargin: '',
    // },
    costbifurcationinfo: {},
    agreementinfo: {
      isagreementfees: '',
      agreementfees: '',
      terms: '',
    },
    traininginfo: {
      noofemployees: '',
      skilledemployees: '',
      nonskilledemployees: '',
      trainingtype: '',
      traininglocation: '',
      recruitmentresp: '',
      trainingperiod: '',
    },
    employeeDetails: {
      headChef: '',
      assistantChef: '',
      waiter: '',
      captain: '',
      restaurantManager: '',
      kitchenSupervisor: '',
      stewardOrWaiter: '',
      cleaner: '',
      kitchenHelper: '',
      commi1: '',
      commi2: '',
    },
    investorprofileinfo: {
      involvement: {
        partTime: false,
        fullTime: false,
        occasionally: true,
      },
      investmentbudget: [500000, 751868],
      jobType: [],
      investmentSource: [],
      location: [],
      industry: [],
    },
    infrastructureAndAutomation: {
      infrastructure: '',
      automation: '',
    },
    salesinfo: {
      monthlysale: '',
      quaterlysale: '',
    },
  },
  photodocinfo: {
    photos: [],
    docs: [],
    menus: [],
  },
  contactdetails: {
    contactinfo: {
      firstname: '',
      lastname: '',
      mobileno: '',
      email: '',
      designation: '',
      landlineno: '',
      address: '',
      landmark: '',
      city: undefined,
      state: undefined,
      country: undefined,
      pincode: '',
    },
    alternatecontact: {
      name: '',
      designation: '',
      mobileno: '',
      email: '',
    },
  },
};
let initialCatalog = {
  branddetails: {
    brandinfo: {
      companyname: 'FD',
      brandname: 'FD',
      outlets: 2,
      brandorigin: 'India',
      establishmentyear: '1996',
      franchiseyear: '1995',
      googlerating: '5',
      fnbtype: '',
      description: 'Desc',
      logo: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8Zm9vZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60',
      businessmodel: ['FOFO'],
    },
    statutoryinfo: {
      gstin: 'ABCTY1234A',
      pan: 'ABCTY1234B',
      tin: 'ABCTY1234C',
      cin: 'ABCTY1234D',
    },
    natureofbusinessinfo: {
      businesscategoryname: [
        { value: '64267c0b753b81770c8f2355', label: 'Logistics' },
      ],
      categoryname: [
        { value: '642a8d15753b81770c8fa145', label: 'Freight & logistics' },
      ],
      subcategoryname: [
        { value: '642c56a5753b81770c8fd915', label: 'Online Delivery' },
      ],
      othercategory: '',
      ownershiptype: 'Partnership',
      annualturnover: '100000',
      ceoname: 'FD',
      websiteurl: 'https://franchisediscovery.in/',
      googlebusinessurl: 'https://franchisediscovery.in/',
      instagramurl: 'https://franchisediscovery.in/',
    },
  },
  franchisedetails: {
    investmentinfo: [
      {
        businesstype: {
          label: 'Freight & Logistics',
          value: '642847cb753b81770c8f3644',
        },
        spacearea: 100,
        setupcost: 100,
        rawmaterialcost: 100,
        licensescost: 100,
        miscellaneousexpense: 100,
        securitydeposit: 100,
        franchisefees: 100,
        additionaldetails: 'Details',
      },
    ],
    marketinginfo: {
      marketing: 'brand',
      marketingtype: [
        {
          label: 'Digital Media',
          value: 'Digital Media',
        },
      ],
    },
    masterinfo: {
      country: [
        {
          value: '643a7e561c11a74338a882bf',
          label: 'India',
        },
      ],
      state: [
        {
          value: '643a7e571c11a74338a8863c',
          label: 'Chhattisgarh',
        },
      ],
      city: [
        {
          value: '643a7e5b1c11a74338a891d9',
          label: 'Achalpur',
        },
      ],
      masterfranchisefees: 10000,
      setupcost: 10000,
      totalinvestment: 100,
      royalty: 100,
      agreementyears: '1996',
      roi: '9-12',
    },
    analysisinfo: {
      rent: 100000,
      electricityexpenses: 10000,
      royalty: 10000,
      royalty_unit: 'percent',
      agreementyears: '1996',
      workingcapital: 500000,
      roi: '9-12',
      miscellaneousexpenses: 1000,
      totalexpenses: 200000,
      brand_revenuesharing: 40,
      brand_revenuesharing_unit: 'percent',
      franchise_revenuesharing: 40,
      franchise_revenuesharing_unit: 'percent',
      analysisinfo: 12000000,
    },
    cityinfo: {
      existingcountry: [
        {
          value: '643a7e561c11a74338a882bf',
          label: 'India',
        },
      ],
      existingstate: [
        {
          value: '643a7e561c11a74338a882c1',
          label: 'Andaman and Nicobar Islands',
        },
      ],
      existingcity: [
        {
          value: '643a7e5b1c11a74338a891d9',
          label: 'Achalpur',
        },
      ],
      expansioncountry: [
        {
          value: '643a7e561c11a74338a882bf',
          label: 'India',
        },
      ],
      expansionstate: [
        {
          value: '643a7e561c11a74338a882c1',
          label: 'Andaman and Nicobar Islands',
        },
      ],
      expansionscity: [
        { value: '643a7e571c11a74338a88467', label: 'Abhayapuri' },
      ],
      blockcountry: [
        {
          value: '643a7e561c11a74338a882bf',
          label: 'India',
        },
      ],
      blockstate: [
        {
          value: '643a7e571c11a74338a8863c',
          label: 'Chhattisgarh',
        },
      ],
      blockcity: [{ value: '643a7e5e1c11a74338a89af2', label: 'Abiramam' }],
    },
  },
  pagesinfo: {
    aboutus: {
      desc: '',
      img: 'https://cdn-icons-png.flaticon.com/512/1078/1078454.png',
    },

    support: {
      desc: 'supportme',
      img: 'https://cdn-icons-png.flaticon.com/512/1078/1078454.png',
    },
    awards: [
      {
        desc: 'aws',
        img: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8Zm9vZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60',
      },
    ],
    products: [
      {
        desc: 'aaa',
        img: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8Zm9vZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60',
      },
      {
        desc: 'aaa',
        img: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8Zm9vZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60',
      },
    ],
    faqs: [
      {
        question: 'aaa',
        answer: 'aaa',
      },
      {
        question: 'aaa',
        answer: 'aaa',
      },
    ],
    others: {
      heading: 'aaa',
      desc: 'aa',
      img: 'aaa',
    },
  },
  additionalinfo: {
    costbifurcationinfo: {
      rent: 10,
      salary: 20,
      products: 30,
      marketing: 40,
      miscellaneous: 50,
      wastage: 60,
      accomadation: 70,
      otherinfo: 80,
      profitmargin: 90,
    },
    agreementinfo: {
      isagreementfees: 'yes',
      agreementfees: 9000,
      terms: '3 Years',
    },
    traininginfo: {
      noofemployees: 0,
      skilledemployees: 0,
      nonskilledemployees: 0,
      trainingtype: 'Brand',
      traininglocation: 'Brand',
      recruitmentresp: 'Franchise',
      trainingperiod: '12',
    },
    employeeDetails: {
      headChef: '1',
      assistantChef: '2',
      waiter: '',
      captain: '',
      restaurantManager: '',
      kitchenSupervisor: '',
      stewardOrWaiter: '',
      cleaner: '',
      kitchenHelper: '',
      commi1: '',
      commi2: '',
    },
    investorprofileinfo: {
      involvement: {
        partTime: false,
        fullTime: false,
        occasionally: true,
      },
      investmentbudget: [900000, 110000],
      jobType: ['Business'],
      investmentSource: ['Self'],
      location: ['Rented'],
      industry: [
        {
          label: 'Asian paint dealer',
          value: '643a7d881c11a74338a87f94',
        },
      ],
    },
    infrastructureAndAutomation: {
      infrastructure: 'casual',
      automation: 'fully',
    },
    salesinfo: {
      monthlysale: 10000,
      quaterlysale: 30000,
    },
  },
  photodocinfo: {
    photos: [
      {
        desc: 'a-k-IHvHq9GpVGg-unsplash.jpg',
        img: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/bd3a287f-e5b8-4fbf-a4cb-af07d83c09d9.jpg',
      },

      {
        desc: 'a-k-JrnteoTqTZM-unsplash.jpg',
        img: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/11763ca1-f006-4604-9dda-f3caf9bdc614.jpg',
      },

      {
        desc: 'eduardo-bergen-a1V5iA9UTDc-unsplash.jpg',
        img: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/a77d92d9-1fd6-4970-946b-ffb2966bcf05.jpg',
      },

      {
        desc: 'file_example_JPG_2500kB.jpeg',
        img: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/1d9c0f2d-e368-4961-a760-f25ca398b362.jpeg',
      },
      {
        desc: 'file_example_JPG_2500kB.jpeg',
        img: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/acbd0c08-7fec-4550-bd22-051ce10770f5.jpg',
      },
      {
        desc: 'file_example_JPG_2500kB.jpeg',
        img: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/7e26ed53-557d-4b8b-acbe-eb494e1eb770.jpg',
      },
    ],
    docs: [
      {
        doc: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/5fc30e8d-79e4-4e64-b1f4-25b01ab75bbe.pdf',
      },
      {
        doc: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/143e20f4-4abd-46ad-b4e7-1afad38eb165.pdf',
      },
    ],
    menus: [
      {
        doc: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/5fc30e8d-79e4-4e64-b1f4-25b01ab75bbe.pdf',
      },
      {
        doc: 'https://fd-upload.s3-accelerate.amazonaws.com/user/645e532c4adce2c96bb829cf/photodocinfo/photos/143e20f4-4abd-46ad-b4e7-1afad38eb165.pdf',
      },
    ],
  },
  contactdetails: {
    contactinfo: {
      firstname: 'Deepak',
      lastname: 'Mahana',
      mobileno: '98393893',
      email: 'm@gmail.com',
      designation: 'CEO',
      landlineno: '09898398293',
      address:
        'akjioweuruijkasjd kjalkjakjdajdaji owqueqirahdjahdjk ahdjadajdhajdhajd',
      landmark: 'akjdksda',
      city: 'Mumbai',
      state: 'Maharashtra',
      country: 'India',
      pincode: 400086,
    },
    alternatecontact: {
      name: 'Deepak',
      designation: 'CEO',
      mobileno: '98393893',
      email: 'm@gmail.com',
    },
  },
};

initialCatalog = initialCatalogProd;
//initialCatalog = initialCatalog;

const initialState = {
  // catalog:
  //   window.location.hostname === 'localhost'
  //     ? initialCatalog
  //     : initialCatalogProd,
  catalog: initialCatalog,
  tabindex: 0,
  loading: false,
  error: null,
  catalouge_id: null,
  brand_user_id: null,
  status: null,
  isEdit: true,
  catalog_fetching: false,
  catalogDropdowns: {},
  industry: [],
  brandUser: {},
  bussinessCategories: [],
  bussinessTypes: [],
  countries: [],
  states: [],
  cities: [],
  zones: [],
  costBifurcationData: null,
  employeeDetails: null,
  licenseType: null,
};

export const catalogReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_CATALOG:
      return {
        ...state,
        catalog: payload,
      };
    case ActionTypes.SET_CATALOG_COUNT:
      return {
        ...state,
        tabindex: payload,
      };
    case ActionTypes.MANAGE_CATALOG_FORM_LOADING:
      return {
        ...state,
        loading: true,
      };
    case ActionTypes.MANAGE_CATALOG_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        catalog_fetching: false,
        error: payload,
      };
    case ActionTypes.MANAGE_CATALOG_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        status: payload?.status || null,
        isEdit: payload?.status && state.tabindex == 5 ? false : true,
      };
    case ActionTypes.MANAGE_CATALOG_BRAND_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        catalouge_id: payload._id,
        brand_user_id: payload.branduserid,
      };
    case ActionTypes.SET_CATALOG_FORM_EDITABLE:
      return {
        ...state,
        isEdit: true,
      };

    case ActionTypes.FETCH_CATALOG_DETAILS_LOADING:
      return {
        ...state,
        catalog_fetching: true,
      };
    case ActionTypes.FETCH_CATALOG_DETAILS_SUCCESS:
      //console.log('FETCH_CATALOG_DETAILS_SUCCESS', payload);
      const {
        branddetails: branddetailsData,
        additionalinfo,
        franchisedetails,
        pagesinfo,
        photodocinfo,
        contactdetails,
        status,
        _id,
        branduserid,
      } = payload || {};

      let modifiedBranddetails = {
        ...branddetailsData,
        natureofbusinessinfo: {
          ...branddetailsData?.natureofbusinessinfo,
          businesscategoryname: getLabelValueData(
            branddetailsData?.natureofbusinessinfo?.businesscategoryname
          ),
          categoryname: getLabelValueData(
            branddetailsData?.natureofbusinessinfo?.categoryname
          ),
          subcategoryname: getLabelValueData(
            branddetailsData?.natureofbusinessinfo?.subcategoryname
          ),
        },
        statutoryinfo: {
          ...branddetailsData?.statutoryinfo,
          licensetype: getLabelValueData(
            branddetailsData?.statutoryinfo?.licensetype
          ),
        },
      };
      // console.log('modifiedBranddetails', modifiedBranddetails);
      // console.log('branddetails', state.catalog.branddetails);

      let modifiedFranchiseDetails = {
        ...franchisedetails,
        cityinfo: {
          //existing
          existingcountry: getLabelValueData(
            franchisedetails?.cityinfo?.existingcity[0].country
          ),
          existingstate: getLabelValueData(
            franchisedetails?.cityinfo?.existingcity[0].state
          ),
          existingcity: getLabelValueData(
            franchisedetails?.cityinfo?.existingcity[0].city
          ),

          //expansion
          expansioncountry: getLabelValueData(
            franchisedetails?.cityinfo?.expansioncity[0].country
          ),
          expansionstate: getLabelValueData(
            franchisedetails?.cityinfo?.expansioncity[0].state
          ),
          expansionscity: getLabelValueData(
            franchisedetails?.cityinfo?.expansioncity[0].city
          ),

          //block
          blockcountry: getLabelValueData(
            franchisedetails?.cityinfo?.blockcity[0].country
          ),
          blockstate: getLabelValueData(
            franchisedetails?.cityinfo?.blockcity[0].state
          ),
          blockcity: getLabelValueData(
            franchisedetails?.cityinfo?.blockcity[0].city
          ),
        },

        masterinfo: {
          ...franchisedetails?.masterinfo,
          country: getLabelValueData(franchisedetails?.masterinfo.country),
          state: getLabelValueData(franchisedetails?.masterinfo.state),
          city: getLabelValueData(franchisedetails?.masterinfo.city),
        },

        investmentinfo: franchisedetails?.investmentinfo.map((obj) => {
          obj.businesstype = {
            label: obj?.businesstype?.name,
            value: obj?.businesstype?._id,
          };
          return obj;
        }),
        marketinginfo: {
          ...franchisedetails?.marketinginfo,
          marketingtype: getLabelValueData(
            franchisedetails?.marketinginfo?.marketingtype
          ),
        },
        analysisinfo: {
          ...franchisedetails?.analysisinfo,
          brand_revenuesharing:
            franchisedetails?.analysisinfo?.revenuesharing?.brand?.value,
          brand_revenuesharing_unit:
            franchisedetails?.analysisinfo?.revenuesharing?.brand?.type,
          franchise_revenuesharing:
            franchisedetails?.analysisinfo?.revenuesharing?.franchise?.value,
          franchise_revenuesharing_unit:
            franchisedetails?.analysisinfo?.revenuesharing?.franchise?.type,
          royalty_unit: franchisedetails?.analysisinfo?.royalty?.type,
          royalty: franchisedetails?.analysisinfo?.royalty?.value,
        },
      };
      //console.log('modifiedFranchiseDetails', modifiedFranchiseDetails);

      let modifiedAdditionalInfo = {
        ...additionalinfo,
        investorprofileinfo: {
          ...additionalinfo?.investorprofileinfo,
          industry: getLabelValueData(
            additionalinfo?.investorprofileinfo?.industry
          ),
        },
      };

      let contactdetailsData = {
        ...contactdetails,
        contactinfo: {
          ...contactdetails?.contactinfo,
          city: {
            label: contactdetails?.contactinfo?.city?.name,
            value: contactdetails?.contactinfo?.city?._id,
          },
          country: {
            label: contactdetails?.contactinfo?.country?.name,
            value: contactdetails?.contactinfo?.country?._id,
          },
          state: {
            label: contactdetails?.contactinfo?.state?.name,
            value: contactdetails?.contactinfo?.state?._id,
          },
        },
      };
      //console.log('modifiedAdditionalInfo', modifiedAdditionalInfo);

      let catalog = {
        branddetails: branddetailsData
          ? modifiedBranddetails
          : state.catalog.branddetails,
        franchisedetails: franchisedetails
          ? modifiedFranchiseDetails
          : state.catalog.franchisedetails,
        pagesinfo: pagesinfo || state.catalog.pagesinfo,
        additionalinfo: additionalinfo
          ? modifiedAdditionalInfo
          : state.catalog.additionalinfo,
        photodocinfo: photodocinfo || state.catalog.photodocinfo,
        contactdetails: contactdetailsData || state.catalog.contactdetails,
      };

      return {
        ...state,
        catalog_fetching: false,
        loading: false,
        catalog: catalog,
        catalouge_id: _id || null,
        brand_user_id: branduserid || null,
        status: status || null,
        //isEdit: true,
        isEdit: ['PUBLISHED', 'UNDER_VERIFICATION'].includes(status)
          ? false
          : true,
      };
    case ActionTypes.FETCH_CATALOG_DETAILS_FAILURE:
      return {
        ...state,
        catalog_fetching: false,
        error: payload,
        catalog: initialCatalog,
        tabindex: 0,
        catalouge_id: null,
        brand_user_id: null,
        status: null,
        isEdit: true,
        loading: false,
      };
    case ActionTypes.UPDATE_CATELOG:
      const { catelogSection, data } = payload;
      let tempCatelog = { ...state.catalog };
      tempCatelog[catelogSection] = data;
      return {
        ...state,
        catalog: tempCatelog,
      };
    case ActionTypes.RESET_CATALOG:
      return {
        ...state,
        catalog: initialCatalog,
        tabindex: 0,
        catalouge_id: null,
        brand_user_id: null,
        status: null,
        isEdit: true,
      };
    case ActionTypes.GET_DROPDOWN_DATA:
      return {
        ...state,
        catalogDropdowns: payload.data,
      };
    case ActionTypes.GET_INDUSTRY:
      return {
        ...state,
        industry: payload.data,
      };

    case ActionTypes.GET_BUSSINESS_CATEGORY_DATA:
      return {
        ...state,
        bussinessCategories: payload?.data?.categories || [],
      };
    case ActionTypes.GET_BUSSINESS_TYPE_DATA:
      return {
        ...state,
        bussinessTypes: sortBussinessTypeData(payload.data),
      };
    case ActionTypes.SET_BRAND_USER:
      return {
        ...state,
        brandUser: payload,
      };

    case ActionTypes.FETCH_COUNTRIES:
      return {
        ...state,
        countries: payload,
      };
    case ActionTypes.FETCH_STATES:
      return {
        ...state,
        states: payload,
      };

    case ActionTypes.FETCH_CITIES:
      return {
        ...state,
        cities: payload,
      };
    case ActionTypes.FETCH_ZONES:
      return {
        ...state,
        zones: payload,
      };

    case ActionTypes.GET_COST_BIFURCATION_DATA:
      return {
        ...state,
        costBifurcationData: payload,
      };
    case ActionTypes.GET_EMPLOYEE_DETAILS_DATA:
      return {
        ...state,
        employeeDetails: payload,
      };

    case ActionTypes.GET_LICENSE_TYPE_DATA:
      return {
        ...state,
        licenseType: payload,
      };

    case ActionTypes.PUBLISH_CATALOG_LOADING:
      return {
        ...state,
        publish_loading: true,
        publishErrorMessage: null,
        publishSuccessMessage: null,
      };
    case ActionTypes.PUBLISH_CATALOG_SUCCESS:
      console.log('Success reducer', payload);
      return {
        ...state,
        publish_loading: false,
        publishSuccessMessage: payload?.message,
        publishErrorMessage: null,
        status: 'PUBLISHED',
        isEdit: false,
      };
    case ActionTypes.PUBLISH_CATALOG_FAILURE:
      return {
        ...state,
        publish_loading: false,
        publishErrorMessage: payload,
        publishSuccessMessage: null,
      };
    default:
      return state;
  }
};
